import React, { RefObject } from "react";
import { TableCell } from "./TableCell";

interface TableRowProps {
	row: Array<any>;
	rowIndex: number;
	isActive: boolean;
	onClick: () => void;
	headers: string[];
	isVirtualized: boolean;
	virtualRowStart?: number;
	virtualRowSize?: number;
	activeRowRefDiv?: RefObject<HTMLDivElement> | null;
	activeRowRefTr?: RefObject<HTMLTableRowElement> | null;
}

/**
 * Shared row component for both virtualized and non-virtualized table rows
 */
export function TableRow({
	row,
	rowIndex,
	isActive,
	onClick,
	headers,
	isVirtualized,
	virtualRowStart,
	virtualRowSize,
	activeRowRefDiv,
	activeRowRefTr,
}: TableRowProps) {
	if (isVirtualized) {
		return (
			<div
				ref={isActive ? activeRowRefDiv : null}
				className={`data-table__virtual-row ${isActive ? "active" : ""}`}
				onClick={onClick}
				style={{
					position: "absolute",
					top: `${virtualRowStart}px`,
					left: 0,
					width: "100%",
					height: `${virtualRowSize}px`,
					cursor: "pointer",
				}}
			>
				{row.map((value, colIndex) => (
					<TableCell key={colIndex} value={value} colIndex={colIndex} row={row} isVirtualized={true} />
				))}
			</div>
		);
	}

	return (
		<tr ref={isActive ? activeRowRefTr : null} className={isActive ? "active" : ""} onClick={onClick} style={{ cursor: "pointer" }}>
			{row.map((value, colIndex) => (
				<TableCell key={colIndex} value={value} colIndex={colIndex} row={row} isVirtualized={false} />
			))}
		</tr>
	);
}
